module.exports = __webpack_public_path__ + "static/img/btn_close.2643fad6.png";